import React, {Component} from "react";
import {request} from "../../api-client";
import {AllViewContainer} from "../../components/Letflow/ViewContainer";
import GridContainer from "../../components/Grid/GridContainer";
import GridItem from "../../components/Grid/GridItem";
import Card from "../../components/Card/Card";
import CardBody from "../../components/Card/CardBody";
import localization from "../../config/localization";

export default class extends Component {
  constructor() {
    super();
    this.state = {
      metrics: [],
    }
  }

  componentDidMount = () => {
    request.metrics.get()
      .then(response => this.setState({metrics: response}))
  }


  render() {
    if(this.state.metrics.length < 1) return null
    return(
      <AllViewContainer ref="viewContainer">
        <GridContainer>
          <GridItem xs={12}>
            <Card>
              <CardBody>
                <h3>{localization.get('metrics.general')}</h3>
                <div style={{display: "grid", width: "100%", gridGap: 10, gridTemplateColumns: "repeat(3, 33%)"}}>
                  {this.state.metrics.general.map(element =>
                    <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between"}}>
                      <div>{localization.get(element.entity)}</div>
                      <div>{localization.get(element.count)}</div>
                    </div>
                  )}
                </div>
                <h3>{localization.get('metrics.contents')}</h3>
                <div style={{display: "grid", width: "100%", gridGap: 10, gridTemplateColumns: "repeat(3, 33%)"}}>
                  {this.state.metrics.contents.map(element =>
                    <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between"}}>
                      <div>{localization.get(element.entity)}</div>
                      <div>{localization.get(element.count)}</div>
                    </div>
                  )}
                </div>
                <h3>{localization.get('metrics.other')}</h3>
                <div style={{display: "grid", width: "100%", gridGap: 10, gridTemplateColumns: "repeat(3, 33%)"}}>
                  {this.state.metrics.other.map(element =>
                    <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between"}}>
                      <div>{localization.get(element.entity)}</div>
                      <div>{localization.get(element.count)}</div>
                    </div>
                  )}
                </div>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </AllViewContainer>
    )
  }
}